module.exports = __webpack_public_path__ + "img/home-farmhouse-kitchen.8e05404a.jpg";